export default __webpack_public_path__ + "static/media/RaamdeoAggarwal.ed244005.png";